import axios, { AxiosResponse } from 'axios';
import { reportErrorSentry } from 'src/bff';
import { DomainAttributesValues, InstallationResponse } from 'src/types';
import { getMolecularCdnUrl } from '../get-molecular-cdn-url';

export const getInstallations = async (token: string, addPosventa?: boolean): Promise<{ attributes: DomainAttributesValues[] }[]> => {
  const molecularCdnUrl = getMolecularCdnUrl();
  const domain = addPosventa ? 'Installations_VW_All' : 'Installation';

  try {
    const installations: AxiosResponse<InstallationResponse> = await axios.get(
      `${molecularCdnUrl}/request-dps-domain.php?token=${token}&domain=${domain}`
    );
    return installations.data.content;
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
